const LOAD_DATA_REPORT_HIRING_PIPELINE           = 'LOAD_DATA_REPORT_HIRING_PIPELINE'
const LOAD_DATA_REPORT_HIRING_PIPELINE_SUCCESS   = 'LOAD_DATA_REPORT_HIRING_PIPELINE_SUCCESS'
const LOAD_DATA_REPORT_HIRING_PIPELINE_FAILED    = 'LOAD_DATA_REPORT_HIRING_PIPELINE_FAILED'
const UNMOUNT_DATA_REPORT_HIRING_PIPELINE        = 'UNMOUNT_DATA_REPORT_HIRING_PIPELINE'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const reportHiringPipeline = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_REPORT_HIRING_PIPELINE:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_REPORT_HIRING_PIPELINE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_REPORT_HIRING_PIPELINE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_REPORT_HIRING_PIPELINE:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default reportHiringPipeline;